import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import ExampleComponent from '../ExampleComponent'
import FlightPaths from '../FlightPaths'
import GlobeView from '../GlobeView'
// import MapEurope from '../MapEurope'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { useEffect, useState } from 'react'
import TitleLead from 'components/TitleLead/TitleLead'

import GlobalContext from 'Contexts/GlobalContext'
import InfoBoardNormal from 'components/InfoBoardNormal/InfoBoardNormal'
import { localeDE } from 'Content/locale_de'
import { localeFR } from 'Content/locale_fr'
import { Scroller } from "@ta-interaktiv/react-scroller";

const people = ['Gigi Oeri', 'Familie Hayek', 'Rainer-Marc Frey', 'Rolex']
const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const [height, setHeight] = useState(0)
  const [currentTime, setCurrentTime] = useState(0)
  const [currentDistance, setCurrentDistance] = useState("0")
  const [scrollIndex, setScrollIndex] = useState(0)
  const [headerHeight, setHeaderHeight] = useState(0)

  useEffect(() => {
    const headerElement = document.querySelector('[class*=FullHeader_root]')

    let headerHeight = 0
    if (headerElement) {
      // check if header is sticky
      const headerStyle = window.getComputedStyle(headerElement)
      const isSticky =
        headerStyle.position === 'sticky' && headerStyle.top === '0px'

      if (isSticky) {
        headerHeight = headerElement.clientHeight
        setHeaderHeight(headerHeight)
      }
    }
    setHeight(window.innerHeight)
  }, [])
  const currentLocale = tenant.lang === 'de' ? localeDE : localeFR
  return (
    <AppContainer $colorMode={colorMode} addMargin={!properties?.isHeader}>
      {/* <GlobeView /> */}
      {/* <MapEurope stage={1} /> */}
      {/* <SectionGray colorMode={colorMode}>
        <GlobeView />
      </SectionGray> */}
      {properties?.isHeader ? (
        <TitleLead colorMode={colorMode} tenant={tenant} />
      ) : (
        <>
          {/* <MapEurope stage={1} colorMode={colorMode} /> */}
          <GlobalContext.Provider
            value={{
              currentTime,
              setCurrentTime,
              currentDistance,
              setCurrentDistance,
              scrollIndex,
              setScrollIndex,
              colorMode,
              lang: tenant.lang,
              locale: currentLocale,
              headerHeight: headerHeight,
            }}
          >
            <InfoBoardNormal
              person={people[scrollIndex]}
              currentDistance={String(currentDistance)}
              currentTime={String(currentTime)}
            />
            <Scroller
              defaultDistance={height}
              front={currentLocale.scrollyTellingFrontContent}
              back={(index: number) => {
                return (
                  <FlightPaths
                    colorMode={colorMode}
                    scrollIndex={Math.min(index, 3)}
                  />
                )
              }}
            />
          </GlobalContext.Provider>
        </>
      )}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)<{addMargin: boolean}>`${GlobalVariables}
  /* font-family: var(--font-sans-serif); */
  font-size: 1.8rem;
  line-height: 3rem;
  color: var(--text-color);
  margin-bottom: ${(props) => (props.addMargin ? '3rem' : '0')};
  /* overflow: hidden; */
`

const BackElement = styled.div`
  /* padding-top: 4vh; */
  @media only screen and (max-width: 542px) {
    padding-top: 0;
  }
  img {
    @media only screen and (max-width: 542px) {
    }
  }
  div {
    position: absolute;
    width: 100vw;
    background-size: contain;
    background-position: center, center;
    background-repeat: no-repeat;
    transition: opacity 0.6s linear;
    -webkit-transition: opacity 0.6s linear;
  }
  /* transition: opacity 1s ease-out; */
`

const SectionGray = styled.div<{ colorMode: string | undefined }>`
  /* background-color: ${(props) =>
    props.colorMode === 'dark'
      ? 'var(--brandblue-bright-1)'
      : 'var(--beige-bright-3)'}; */
  margin-top: 20px;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export default MainComponent
